import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import pbicon from './../../assets/PB.png'

const styles = () => ({
  root: {
    width: '100%',
    padding: '16px 0',
    display: 'flex',
    justifyContent: 'flex-start',
  },

  rowInner: {
    width: 'min(100%, 720px)',
    display: 'grid',
    gridTemplateColumns: 'minmax(200px, 280px) minmax(260px, 420px)',
    columnGap: 20,
    alignItems: 'center',
  },

  thumbWrap: {
    position: 'relative',
    width: '100%',
    aspectRatio: '16 / 9',
    overflow: 'hidden',
    background: '#0E2D54',

    '&:hover $shade, &:focus-within $shade': { opacity: 0.42 },
    '&:hover $playBtn, &:focus-within $playBtn': { transform: 'scale(1.06) translateZ(0)' },
  },

  thumbImg: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },

  shade: {
    position: 'absolute',
    inset: 0,
    background: '#000',
    pointerEvents: 'none',
    transition: 'opacity .18s ease',
    opacity: 0.18,
  },

  playCenter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'grid',
    placeItems: 'center',
    pointerEvents: 'none',
  },

  playBtn: {
    pointerEvents: 'auto',
    width: 56,
    height: 56,
    border: 0,
    borderRadius: '50%',
    background: '#0C70E8E5',
    boxShadow: '0px 4px 4px rgba(0,0,0,0.15)',
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    transform: 'scale(1) translateZ(0)',
    transformOrigin: 'center',
    transition: 'transform .18s ease',
    willChange: 'transform',
    backfaceVisibility: 'hidden',
  },

  playIcon: { width: 22, height: 22, fill: '#fff', transform: 'translateX(1px)' },

  info: {
    minWidth: 0,
    alignSelf: 'start',
  },
  title: {
    margin: 0,
    fontFamily: 'var(--font-sans)',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '28px',
    letterSpacing: '-0.02em',
    color: '#002857',
  },
  meta: {
    marginTop: 6,
    fontFamily: 'var(--font-sans)',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: '#305178',
  },

  '@media (max-width:1279px)': {
    rowInner: {
      width: 'min(100%, 640px)',
      gridTemplateColumns: 'minmax(180px, 260px) minmax(240px, 380px)',
      columnGap: 16,
    },
    title: { fontSize: 22, lineHeight: '30px' },
    playBtn: { width: 52, height: 52 },
  },
  '@media (max-width:768px)': {
    rowInner: {
      width: '100%',
      gridTemplateColumns: '1fr',
      rowGap: 12,
    },
    playBtn: { width: 48, height: 48 },
    title: { fontSize: 20, lineHeight: '28px' },
  },
})

function getYoutubeId(url) {
  if (!url) return null
  try {
    const u = new URL(url)
    if (u.hostname.includes('youtu.be')) return u.pathname.slice(1)
    const v = u.searchParams.get('v')
    if (v) return v
    const m = u.pathname.match(/\/embed\/([0-9A-Za-z_-]{11})/)
    if (m) return m[1]
  } catch {}
  const m2 = String(url).match(/(?:v=|\/embed\/|youtu\.be\/)([0-9A-Za-z_-]{11})/)
  return m2 ? m2[1] : null
}
function thumbFromData(data) {
  const direct =
    data?.thumbnail ||
    data?.thumbnails?.maxres?.url ||
    data?.thumbnails?.high?.url ||
    data?.thumbnails?.medium?.url
  if (direct) return direct
  const id = getYoutubeId(data?.url)
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : pbicon
}
function formatDuration(totalSeconds = 0) {
  const s = Math.max(0, Number(totalSeconds) || 0)
  const m = Math.floor(s / 60)
  const sec = String(Math.floor(s % 60)).padStart(2, '0')
  return `${m}:${sec}`
}

function ItemVideo({ classes, data, configData }) {
  const { title, category, duration, url } = data || {}
  const { anchorLinked, onclickedPbIcon } = configData || {}
  const thumb = thumbFromData(data)
  const open = () => typeof onclickedPbIcon === 'function' && onclickedPbIcon(url)

  const Thumb = (
    <div className={classes.thumbWrap} onClick={open} role="button">
      <img className={classes.thumbImg} src={thumb} alt={title || 'video'} />
      <span className={classes.shade} aria-hidden="true" />
      <div className={classes.playCenter}>
        <button type="button" className={classes.playBtn} onClick={open} aria-label="Play video">
          <svg viewBox="0 0 24 24" className={classes.playIcon}><path d="M8 5v14l11-7z" /></svg>
        </button>
      </div>
    </div>
  )

  return (
    <div className={classes.root}>
      <div className={classes.rowInner}>
        {anchorLinked ? (
          <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            {Thumb}
          </a>
        ) : (
          Thumb
        )}
        <div className={classes.info}>
          <h3 className={classes.title}>{title}</h3>
          <div className={classes.meta}>
            {category} | {formatDuration(duration)}
          </div>
        </div>
      </div>
    </div>
  )
}

ItemVideo.defaultProps = {
  data: { title: '', duration: 0, url: '', category: '', product: '' },
  configData: { anchorLinked: false, onclickedPbIcon: null },
}
ItemVideo.propTypes = { data: PropTypes.object.isRequired, configData: PropTypes.object }

export default withStyles(styles)(ItemVideo)
